<picture>
  <img
    *ngIf="!desabilitar"
    #sorvetePremiado
    (click)="navigateToPalitoPremiado()"
    class="sorvete_premiado_link"
    src="assets/images/palito-premiado/link_sorvete_premiado.png"
    alt="Medalha Sorvete Premiado"
    title="Medalha Sorvete Premiado"
  />
  <div
    class="close__badge"
    #closeTag
    (click)="hiddenTag()"
    *ngIf="!desabilitar"
  >
    <img src="assets/images/icons/x.png" alt="" />
  </div>
</picture>
